import { Anskaffningsformer, Avverkningsgrupper } from "~app/common/models/constants";
import { IArbetsorder } from "~app/features/planera/model/IArbetsorder";

export class ArbetsorderHeaderPresentationRulesModel {
    ttVisible: boolean;
    gtVisible: boolean;
    kttVisible: boolean;
    kgtVisible: boolean;
    bmavVisible: boolean;
    lmavVisible: boolean;
    tVisible: boolean;
    gVisible: boolean;
    lVisible: boolean;
    cVisible: boolean;
    noGrotData: boolean;
    detailsIconVisible: boolean;
    restriktionIconVisible: boolean;
    terminalVisible: boolean;
    importVisible: boolean;
    ckVisible: boolean;
    maskinIconVisible: boolean;
    produktsattIconVisible: boolean;
    destineradIconVisible: boolean;
    koordinaterVerifieradeIconVisible: boolean;
    valsStatusIconVisible: boolean;
    voStatusIconVisible: boolean;
    viol3IconVisible: boolean;

    constructor(data: IArbetsorder) {
        this.initalizeModel(data);
        if (data !== undefined) {
            this.setDataRows(data);
        }
    }

    initalizeModel(data: IArbetsorder) {
        this.ttVisible = false;
        this.gtVisible = false;
        this.kttVisible = false;
        this.kgtVisible = false;
        this.bmavVisible = false;
        this.lmavVisible = false;
        this.tVisible = false;
        this.gVisible = false;
        this.lVisible = false;
        this.cVisible = false;
        this.noGrotData = false;
        this.detailsIconVisible = true;
        this.restriktionIconVisible = true;
        this.terminalVisible = false;
        this.ckVisible = false;
        this.importVisible = false;
        this.maskinIconVisible = true;
        this.produktsattIconVisible = true;
        this.destineradIconVisible = true;
        this.koordinaterVerifieradeIconVisible = true;
        this.viol3IconVisible = true;
        if (data.raskVo) {
            this.valsStatusIconVisible = false;
            this.voStatusIconVisible = true;
        } else {
            this.valsStatusIconVisible = true;
            this.voStatusIconVisible = false;
        }
    }

    setDataRows(data: IArbetsorder) {
        // eslint-disable-next-line sonarjs/no-small-switch
        switch (data.avverkningsgrupp) {
            case Avverkningsgrupper.Grotskotning:
                if (this.hasGrotData(data)) {
                    this.tVisible = true;
                    this.gVisible = true;
                    this.lVisible = true;
                    this.cVisible = true;
                } else {
                    this.noGrotData = true;
                }
                this.produktsattIconVisible = false;
                this.destineradIconVisible = false;
                break;
            default:
                this.ttVisible = true;
                this.gtVisible = true;
                this.kttVisible = true;
                this.kgtVisible = true;
                this.bmavVisible = true;
                this.lmavVisible = true;
                break;
        }
        if (!data.isVirkeskop) {
            this.detailsIconVisible = false;
        }
        if (data.isLeveransvirke) {
            this.maskinIconVisible = false;
        }
        if (data.isExternArbetsorder || data.isTerminalImport) {
            if (data.anskaffningsform === Anskaffningsformer.EgenTerminal) {
                this.terminalVisible = true;
            }
            if (data.anskaffningsform === Anskaffningsformer.Import) {
                this.importVisible = true;
            }
            if (data.anskaffningsform === Anskaffningsformer.CentralaKop) {
                this.ckVisible = true;
            }

            this.maskinIconVisible = false;
            this.koordinaterVerifieradeIconVisible = false;
        }
    }

    private hasGrotData(data: IArbetsorder) {
        // eslint-disable-next-line sonarjs/prefer-single-boolean-return
        if (data.andelTall !== null
            || data.andelLov !== null
            || data.andelGran !== null
            || data.andelContorta !== null) {
            return true;
        }
        return false;
    }
}
